/**
 * Created by jimmy on 2019/11/8.
 */

export const host = window.location.origin;
export const env = (host.indexOf('127.0.0.1') > -1 || host.indexOf('local') > -1) ? 'dev' : 'product';

export const apiPrefix = '/api/v1/admin';
export const uploadPrefix = '/api/v1/admin';
export const imgPrefixMobile = env === 'product' ? `https://aj-adjust.oss-cn-beijing.aliyuncs.com/` : 'http://127.0.0.1:9015/';
export const imgPrefix = env === 'product' ? `https://aj-adjust.oss-cn-beijing.aliyuncs.com/` : 'http://127.0.0.1:9015/';
export const uploadfile = env === 'product' ? `https://admin.qpaj.yeekin.cn/` : 'http://127.0.0.1:9015/';;
export const videoPrefix = `/`;

export const appName = '后台数据管理系统';

export const pageLimit = 20;

// 最大删除数据数量
export const deleteMaxCount = 10;

// 最大导出数据数量
export const exportMaxCount = 30;

export const regexpPattern = {
  mobile: /^1[3456789]\d{9}$/,
};

export const eventKeys = {
  listDrawerToggle: 'list-drawer-toggle',
  listDrawerType: 'list-drawer-type',
  leftMenuToggle: 'left-menu-toggle',
};

export const statisticsInterval = [ 1, 7, 30 ];

export const lbskey = 'QKNBZ-GK4ED-77H4V-PTGAQ-AIQKQ-UQFRT';  // https://lbs.qq.com/
